import {getJSONItem} from './storage';
import {USER_KEY} from "./storage-keys";
export const isAuthorized = (token) =>{
    return getJSONItem(USER_KEY).APPTokens.indexOf(token) > -1;
};

export const isCreatedByLoginUser = (email) =>{
  return getJSONItem(USER_KEY).userPrincipalName.toLowerCase() === email.toLowerCase() ;
};
